import { Link } from "react-router-dom";
import styled from "styled-components";

export const CustomBtn = styled(Link)`
  padding: 8px 20px;
  color: white;
  border-radius: 3px;
  font-size: 14px;
`;
